<template>
    <div class="bg1">
    <container v-show="!showRepayList">
        <div class="list-card">
            <div class="list-card-header"> 基本信息 </div>
            <mt-cell-swipe title="汇款人姓名">
                <input style="text-align: right" v-model="repayUserName" placeholder="请填写汇款人姓名"/>
            </mt-cell-swipe>
            <mt-cell-swipe title="汇款人电话">
                <input style="text-align: right" v-model="remitUserMobile" placeholder="请填写汇款人电话"/>
            </mt-cell-swipe>

            <mt-cell-swipe title="汇款金额（元）">
                <input style="text-align: right" v-model="amount" placeholder="请填写汇款人金额"/>
                <span style="margin-left: 10px">元</span>
            </mt-cell-swipe>
            <mt-cell-swipe title="汇款日期" @click.native="showDate = true">
                <span>{{ reimtDate || '选择日期'}}</span>
                <icon value="forward1" color="#bcbcbc" :size="20" />
            </mt-cell-swipe>
            <mt-cell-swipe title="选择款项" @click.native="checkApply">
                <span>{{ applyDateStr || '请选择款项'}}</span>
                <icon value="forward1" color="#bcbcbc" :size="20" />
            </mt-cell-swipe>
        </div>
        <div style="margin-top: 8px"></div>
        <div class="list-card">
            <div class="list-card-header"> 上传凭证 </div>
            <ImageReader :selectImg="selectImg"/>
        </div>
        <div style="margin-top: 8px"></div>
        <div class="list-card—code">
            <SmsCode :mobile="remitUserMobile" @changeSmscode="changeSmsCode"/>
        </div>
        <div style="margin-top: 8px"></div>
        <div class="list-card—code">
            <textarea class="input_tesxt" placeholder="备注（不超过80字）" v-model="remark"></textarea>
        </div>
        <div style="margin-top: 12px"></div>
        <div style="padding: 0 16px">
            <mu-button text="提交" color="primary" class="submit-btn" :disabled="btn_disabled" @click.native="submit"></mu-button>
        </div>
        <div style="margin-top: 12px"></div>
        <mt-popup v-model="showDate" position="bottom" class="repaly_com">
            <mt-cell class="cell" title="请选择日期">
                <mt-button type="primary" plain @click.native="closeDatePopup">完成</mt-button>
            </mt-cell>
            <mt-picker :slots="dateSlots" @change="reimtDateChange" ref="wage" />
        </mt-popup>
    </container>
    <template v-if="showRepayList">
        <RepayList @change="backRepayList"></RepayList>
    </template>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import ImageReader from './components/imageReader';
    import SmsCode from './components/smsCode';
    import RepayList from './repayList'
    import comm from './comm'
    import { validate } from '../../utils/utils';
    import { regexp } from '../../utils/config';
    export default {
        name: "repayMe",
        components: {ImageReader, SmsCode, RepayList},
        data: () => {
            return {
                showRepayList: false,
                // 汇款人姓名
                repayUserName: '',
                // 汇款人电话
                remitUserMobile: '',
                // 汇款金额
                amount: '',
                // 汇款日期
                reimtDate: null,
                tempreimtDate: null,
                // 短信验证码
                code: '',
                // 上传凭条
                applyFile: null,
                // 备注
                remark: '',
                showDate: false,
                btn_disabled: false,
                dateSlots: [{
                    values: [2018, 2019],
                    className: 'slotHouse',
                    textAlign: 'center'
                }, {
                    divider: true,
                    content: '-'
                }, {
                    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                    className: 'slotAddr',
                    textAlign: 'center'
                },{
                    divider: true,
                    content: '-'
                }, {
                    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                        18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                    className: 'slotAddr',
                    textAlign: 'center'
                }]
            }
        },
        computed: {
            ...mapState({
                // 对公还款 选择
                overdueCheck: (state) => Object.assign({}, state.companyRepayState.overdueCheck) || {},
                checkedSum: (state) => state.companyRepayState.checkedSum,
                applyDate: (state) => {
                    return Object.keys(state.companyRepayState.overdueCheck).filter((key) => {
                        if(state.companyRepayState.overdueCheck[key].checked){
                            return key
                        }
                    })
                }
            }),
            applyDateStr() {
                return this.applyDate.length > 0 ?`共${this.applyDate.length}项  ${this.checkedSum}元` : '请选择款项'
            }
        },
        watch: {
            remark: function(val) {
                this.remark = this.remark.slice(0, 80)
            }
        },
        methods:{
            changeSmsCode(val) {
                this.code = val;
            },
            selectImg(file){
                this.applyFile = file;
            },
            // 这里交互有细节问题，用户点击其他地方关闭弹出框的问题
            reimtDateChange(picker, values) {
                this.changeDateSlots(picker, values);
                this.tempreimtDate = `${values[0]}-${values[1]}-${values[2]}`;
            },
            closeDatePopup(){
                this.showDate = false;
                this.reimtDate =  this.tempreimtDate
            },
            checkApply() {
                // this.$router.push({ name: 'companyRepayList' });
                this.showRepayList = true;
            },
            backRepayList() {
                this.showRepayList= false;
            },
            changeDateSlots(picker, values) {
                let v = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                        17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
                if([1, 3, 5, 7, 8, 10, 12].includes(values[1])){
                    v = v.concat([29, 30, 31]);
                }else if([4, 6, 9, 11].includes(values[1])){
                    v = v.concat([29, 30]);
                }
                picker.setSlotValues(2, v);
            },
            submit() {
                const result = validate([{
                    reg: regexp.name,
                    data: this.repayUserName,
                    msg: '请填写正确的汇款人姓名'
                }, {
                    reg: regexp.mobile,
                    data: this.remitUserMobile,
                    msg: '请填写正确的汇款人电话'
                }]);
                if (result !== true) {
                    return this.$showToast({ text: result });
                }
                if(!this.amount || this.amount === ''){
                    return this.$showToast({ text: '请填写汇款金额'});
                }
                if(isNaN(this.amount)){
                    return this.$showToast({ text: '汇款金额必须是数字'});
                }
                if(this.amount <= 0){
                    return this.$showToast({text: '汇款金额必须大于0'});
                }
                if(!this.reimtDate || this.reimtDate === ''){
                    return this.$showToast({ text: '请选择汇款日期'});
                }
                if(!this.applyFile){
                    return this.$showToast({ text: '请上传凭条'});
                }
                if(this.applyDate.length <= 0){
                    return this.$showToast({ text: '请选择款项'});
                }
                if(!this.code || this.code === ''){
                    return this.$showToast({ text: '请填写短信验证码'});
                }
                this.$reportLog('company_repayme_self_submint', 'btn', '为己还款提交');
                this.btn_disabled = true;
                let $this = this;
                comm.uploadRemitFile(this.remitUserMobile, this.code, {
                    repayUserName: this.repayUserName,
                    remitUserMobile: this.remitUserMobile,
                    amount: this.amount,
                    reimtDate: this.reimtDate,
                    applyFile: this.applyFile,
                    requestIds: this.applyDate.toString(),
                    code: this.code,
                    remark: this.remark,
                    mode: 'Self'
                }).then((res) => {
                    $this.btn_disabled = false;
                    if(res.status !== 0){
                        // berrormsg
                        // errormsg
                        return $this.$showToast({ text: res.errormsg});
                    }
                    $this.$showToast({ text: '提交成功'});
                    return this.$router.go(-1);
                }).catch(() => {
                    $this.btn_disabled = false;
                    return $this.$showToast({ text: '服务异常稍后重试'});
                })
            }
        }
    }
</script>

<style scoped>
    .bg1{
        width: 100%;
        height: 100%;
    }
    .list-card{
        padding-left: 2rem;
        background: #fff;
        padding-bottom: 8px;
    }
    .list-card input{
        border-width: 0;
    }
    .list-card—code{
        background: #fff;
    }
    .list-card-header{
        margin-left: -2rem;
        font-size: 18px;
        color: #373f5f;
        padding-left:  2rem;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
    }
    .list-card-header::before{
        content: ' ';
        width: 6px;
        background: #488bf4;
        height: 30px;
        position: absolute;
        left: 0rem;
        top:10px;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }

    .input_tesxt {
        height: 8rem;
        width: 100%;
        border: none;
        padding: 1rem;
        font-size: 14px;
    }
    .cell {
        height: 5.2rem;
    }
    .mint-cell-title {
        flex: 2;
    }
</style>
<style lang="less">
    .repaly_com.mint-popup {
        width: 100%;
        bottom: 0;
        background: #fff;
        .mint-button {
            border: none;
        }
        .mint-cell-wrapper{
            position: relative;
            
            .mint-cell-value {
                position: absolute;
                right: -110px;
                top: 0;
            }
        }
    }

</style>